module.exports = __webpack_public_path__ + "static/widget-img-9-f59396b7aec80a9d4faab23904e0d99d.png";